import React from 'react'
import { observer, useLocalStore } from 'mobx-react-lite'
import { appStore } from '../common/AppStore'
import { SCOPES } from '../config/constants'
import { storeMergedProducts } from '../common/StoreProducts'
import { useDidMount } from '../common/utils/hooks/useDidMount'
import { Bar, BarItem } from '../common/ui-kit/bar'
import { Loader } from '../common/ui-kit/loader'

/**
 * Fetch employee based on current user for scope `Holder` and sets it's value on context `EmployeeCtx`
 */
export const FetchAnon: React.FC = observer(({ children }) => {
  const state = useLocalStore(() => ({
    state: 'initial' as 'initial' | 'loaded' | 'error',
  }))

  useDidMount(() => {
    appStore.isLoggedIn = false
    appStore.currentRole = SCOPES.Public

    storeMergedProducts
      .fetch(appStore.currentRole)
      .then(() => {
        state.state = 'loaded'
      })
      .catch(() => {
        state.state = 'error'
      })
  })

  return state.state === 'loaded' ? (
    <>{children}</>
  ) : (
    <Bar align="middle">
      <BarItem
        isFilling
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: '110px',
          paddingBottom: '110px',
        }}>
        <Loader size="large" />
      </BarItem>
    </Bar>
  )
})
